import { Trans, useTranslation } from 'react-i18next';
import Stars1Icon from '@/assets/icons/stars1.svg?react';
import Stars2Icon from '@/assets/icons/stars2.svg?react';
import PlaneIcon from '@/assets/icons/plane.svg?react';
import HotelIcon from '@/assets/icons/building.svg?react';
import PlanSVG from '@/components/globals/planSVG/PlanSVG';
import styles from './HomeTitle.module.scss';

const HomeTitle = () => {
    return (
        <div className={styles.titleWrapper}>
            <div className={styles.title}>
                {/* <PlanSVG svg={<Stars1Icon />} className={styles.hideMobileImg1} /> */}
                {/* <PlanSVG svg={<Stars2Icon />} className={styles.hideMobileImg2} /> */}
                <h1>
                    <Trans i18nKey="slogan">
                        The magic of
                        <span className={styles.biggerLetters}>Surprise trips</span>
                    </Trans>
                </h1>
            </div>
        </div>
    );
};

export const HomeTitleAloy = () => {
    const { t } = useTranslation();

    return (
        <div className={styles.aloyTitleWrapper}>
            <h1 className={styles.aloyTitle}>{t('travelYourWay')}</h1>
            {/* <div className={styles.iconsContainer}>
                <PlaneIcon className={styles.planeIcon} />
                <span className={styles.plusSign}>+</span>
                <HotelIcon className={styles.hotelIcon} />
            </div> */}
        </div>
    );
};

export default HomeTitle;
